// src/components/expando/expando.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment CrossLinkOutlineFragment on CrossLinkOutline {\n    header\n    subheader\n    description\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment IconFragment on Icon {\n    description\n    size\n    theme\n    title\n    id\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment CrossLinkStandardLinkFragment on EGDSStandardLink {\n    action {\n      resource {\n        value\n      }\n      target\n      analytics {\n        linkName\n        referrerId\n      }\n      accessibility\n    }\n    icon {\n      ...IconFragment\n    }\n    iconPosition\n    text\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment CrossLinkStandardItemFragment on CrossLinkStandardLink {\n    description\n    link {\n      ...CrossLinkStandardLinkFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment CrossLinksGroupItemsFragment on CrossLinksGroupItems {\n    name\n    items {\n      ... on CrossLinkItem {\n        ...CrossLinkStandardItemFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  query ExpandoQuery(\n    $strategyName: String!\n    $context: ContextInput!\n    $uriContext: UriContextInput!\n    $parameters: [CrossLinksParameterInput!]\n    $limit: Int!\n  ) {\n    crosslinksGroups(strategyName: $strategyName, context: $context, uriContext: $uriContext, parameters: $parameters, limit: $limit) {\n      outline {\n        ...CrossLinkOutlineFragment\n      }\n      items {\n        ...CrossLinksGroupItemsFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import React7 from "react";
import { gql as gql6, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/crosslink-outline/crosslink-outline.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkCard } from "uitk-react-cards";
import { UitkHeading, UitkParagraph, UitkSubheading } from "uitk-react-text";
var fragment = gql(_templateObject());
var headerSizeMap = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8
};
var headerTagMap = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6"
};
var CrossLinkOutline = function(props) {
    var data = props.data, headerSize = props.headerSize, headerTag = props.headerTag, secondaryBackgroundColor = props.secondaryBackgroundColor;
    var header = data.header, subheader = data.subheader, description = data.description;
    if (header === "" && subheader === "" && description === "") {
        return null;
    }
    return /* @__PURE__ */ React.createElement(UitkCard, {
        padded: true,
        backgroundTheme: secondaryBackgroundColor ? "secondary" : "primary"
    }, header && /* @__PURE__ */ React.createElement(UitkHeading, {
        size: headerSizeMap[headerSize !== null && headerSize !== void 0 ? headerSize : 6],
        tag: headerTagMap[headerTag !== null && headerTag !== void 0 ? headerTag : "h3"]
    }, header), subheader && /* @__PURE__ */ React.createElement(UitkSubheading, {
        tag: "p"
    }, subheader), description && /* @__PURE__ */ React.createElement(UitkParagraph, {
        size: 3
    }, description));
};
CrossLinkOutline.fragment = fragment;
CrossLinkOutline.displayName = "CrossLinkOutline";
// ../internal/src/components/tracking/impression-tracking.tsx
import React2 from "react";
import { EgClickstreamImpressionTracker } from "@shared-ui/clickstream-analytics-context";
var parameters = {
    event: {
        event_name: "",
        event_type: "",
        event_version: "",
        event_category: ""
    },
    experience: {
        app_name: "shared-ui",
        app_version: "1.0.0",
        page_name: ""
    }
};
function buildEgClickstreamData(params) {
    parameters.event.event_name = params.event.event_name;
    parameters.event.event_type = params.event.event_type;
    parameters.event.event_version = "1.0.0";
    parameters.experience.page_name = params.page_name;
    return parameters;
}
var ImpressionTracking = function(props) {
    var children = props.children, eventData = props.eventData;
    return /* @__PURE__ */ React2.createElement(EgClickstreamImpressionTracker, {
        eventData: buildEgClickstreamData(eventData)
    }, children);
};
// src/components/expando/expando.tsx
import { UitkCard as UitkCard3, UitkCardContentSection } from "uitk-react-cards";
import { UitkExpandoList } from "uitk-react-expando";
// src/components/expando/__private__/__fragments/cross-links-group-items.tsx
import React6 from "react";
import { gql as gql5 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/crosslink-items/crosslink-standard-item.tsx
import React5 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkParagraph as UitkParagraph2 } from "uitk-react-text";
// ../internal/src/components/crosslink-items/crosslink-standard-link.tsx
import React4 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/icon/icon.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var fragment2 = gql2(_templateObject1());
var _obj;
var mapper = (_obj = {}, _defineProperty(_obj, "EXTRA_SMALL" /* EXTRA_SMALL */ , UitkIconSize.EXTRA_SMALL), _defineProperty(_obj, "SMALL" /* SMALL */ , UitkIconSize.SMALL), _defineProperty(_obj, "MEDIUM" /* MEDIUM */ , UitkIconSize.MEDIUM), _defineProperty(_obj, "MEDIUM_LARGE" /* MEDIUM_LARGE */ , UitkIconSize.MEDIUM), _defineProperty(_obj, "LARGE" /* LARGE */ , UitkIconSize.LARGE), _defineProperty(_obj, "XLARGE" /* XLARGE */ , UitkIconSize.XLARGE), _obj);
var Icon = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React3.createElement(UitkIcon, {
        id: data.id,
        name: data.id,
        size: data.size ? mapper[data.size] : void 0,
        title: data.title || void 0,
        description: data.description
    });
};
Icon.fragment = fragment2;
Icon.displayName = "Icon";
// ../internal/src/components/crosslink-items/crosslink-standard-link.tsx
var fragment3 = gql3(_templateObject2(), Icon.fragment);
var CrossLinkStandardLink = function(props) {
    var data = props.data, target = props.target;
    var action = data.action, icon = data.icon, text = data.text, iconPosition = data.iconPosition;
    var analytics = action.analytics, resource = action.resource;
    var clickTracker = useClickTracker();
    var onClickCapture = React4.useCallback(function() {
        return clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        analytics.linkName,
        analytics.referrerId,
        clickTracker
    ]);
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(UitkLink, {
        onClickCapture: onClickCapture
    }, /* @__PURE__ */ React4.createElement("a", {
        href: resource.value,
        target: target
    }, icon && iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React4.createElement(Icon, {
        data: icon
    }), text, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React4.createElement(Icon, {
        data: icon
    }), action.accessibility && /* @__PURE__ */ React4.createElement(UitkText, {
        className: "is-visually-hidden"
    }, action.accessibility))));
};
CrossLinkStandardLink.fragment = fragment3;
CrossLinkStandardLink.displayName = "CrossLinkStandardLink";
// ../internal/src/components/crosslink-items/crosslink-standard-item.tsx
var fragment4 = gql4(_templateObject3(), CrossLinkStandardLink.fragment);
var CrossLinkStandardItem = function(props) {
    var data = props.data, target = props.target;
    var description = data.description, link = data.link;
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(CrossLinkStandardLink, {
        target: target,
        data: link
    }), description && /* @__PURE__ */ React5.createElement(UitkParagraph2, {
        size: 3
    }, description));
};
CrossLinkStandardItem.fragment = fragment4;
CrossLinkStandardItem.displayName = "CrossLinkStandardItem";
// src/components/expando/__private__/__fragments/cross-links-group-items.tsx
import { UitkCard as UitkCard2 } from "uitk-react-cards";
import { UitkExpandoListItem } from "uitk-react-expando";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
import { UitkView } from "uitk-react-view";
var fragment5 = gql5(_templateObject4(), CrossLinkStandardItem.fragment);
var CrossLinksGroupItems = function(props) {
    var data = props.data, collapsedAnalytics = props.collapsedAnalytics, expandedAnalytics = props.expandedAnalytics, expandedByDefault = props.expandedByDefault;
    var items = data.items;
    var _React6_useState = _slicedToArray(React6.useState(expandedByDefault), 2), isVisible = _React6_useState[0], setIsVisible = _React6_useState[1];
    var analytics;
    var clickTracker = useClickTracker2();
    var onToggle = React6.useCallback(function() {
        setIsVisible(!isVisible);
    }, [
        isVisible
    ]);
    if (collapsedAnalytics && expandedAnalytics) {
        analytics = {
            id: isVisible ? collapsedAnalytics.referrerId : expandedAnalytics.referrerId,
            description: isVisible ? collapsedAnalytics.linkName : expandedAnalytics.linkName,
            callback: function(referrerId, linkName) {
                clickTracker(referrerId, linkName);
            }
        };
    }
    return /* @__PURE__ */ React6.createElement(UitkExpandoListItem, {
        analytics: analytics,
        key: "expando-".concat(data.name),
        expandoTitle: /* @__PURE__ */ React6.createElement(UitkHeading2, {
            size: 5,
            tag: "h3"
        }, data.name),
        expandoDescription: /* @__PURE__ */ React6.createElement(UitkCard2, null, /* @__PURE__ */ React6.createElement(UitkLayoutGrid, {
            columns: {
                large: 4,
                small: 1
            },
            space: {
                column: "six"
            },
            "data-stid": "layoutgrid"
        }, _toConsumableArray(Array(4)).map(function(v, k) {
            return /* @__PURE__ */ React6.createElement(UitkLayoutGridItem, {
                key: "grid-item-".concat(k)
            }, /* @__PURE__ */ React6.createElement(UitkView, null, items.map(function(item, index) {
                return (index % 4 === k || index === k) && item.__typename === "CrossLinkStandardLink" && /* @__PURE__ */ React6.createElement(CrossLinkStandardItem, {
                    data: item,
                    target: "_blank" /* BLANK */ ,
                    key: "links-".concat({
                        index: index
                    })
                });
            })));
        }))),
        triggerPosition: "trailing",
        isVisible: isVisible,
        onToggle: onToggle
    });
};
CrossLinksGroupItems.fragment = fragment5;
CrossLinksGroupItems.displayName = "CrossLinksGroupItems";
// src/components/expando/expando.tsx
var __Query = gql6(_templateObject5(), CrossLinkOutline.fragment, CrossLinksGroupItems.fragment);
var defaultImpressionData = {
    event: {
        event_name: "Expando impression",
        event_type: "Impression",
        event_version: "1.0.0",
        event_category: ""
    },
    experience: {
        app_name: "shared-ui",
        app_version: "1.0.0",
        page_name: void 0
    }
};
var CrossLinksExpando = function(props) {
    var _data_crosslinksGroups;
    var inputs = props.inputs, skipSsr = props.skipSsr, collapsedAnalytics = props.collapsedAnalytics, expandedAnalytics = props.expandedAnalytics, _props_impressionData = props.impressionData, impressionData = _props_impressionData === void 0 ? defaultImpressionData : _props_impressionData, _props_expanded = props.expanded, expanded = _props_expanded === void 0 ? true : _props_expanded, _props_enableCache = props.enableCache, enableCache = _props_enableCache === void 0 ? false : _props_enableCache;
    var context = useBexApi().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var fetchPolicy = enableCache ? "cache-first" : "no-cache";
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr,
        fetchPolicy: fetchPolicy
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (error || loading || (data === null || data === void 0 ? void 0 : (_data_crosslinksGroups = data.crosslinksGroups) === null || _data_crosslinksGroups === void 0 ? void 0 : _data_crosslinksGroups.__typename) !== "CrossLinksGroups" || data.crosslinksGroups.items.length === 0) {
        return null;
    }
    var crosslinksGroups = data.crosslinksGroups;
    var outline = crosslinksGroups.outline, items = crosslinksGroups.items;
    return /* @__PURE__ */ React7.createElement(ImpressionTracking, {
        eventData: impressionData
    }, /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(UitkCard3, null, outline && /* @__PURE__ */ React7.createElement(CrossLinkOutline, {
        data: outline,
        headerSize: 5,
        headerTag: "h5",
        secondaryBackgroundColor: true
    }), /* @__PURE__ */ React7.createElement(UitkCardContentSection, null, /* @__PURE__ */ React7.createElement(UitkExpandoList, null, items === null || items === void 0 ? void 0 : items.map(function(group, index) {
        return /* @__PURE__ */ React7.createElement(React7.Fragment, null, group.__typename === "CrossLinksGroupItems" && group.items.length > 0 && /* @__PURE__ */ React7.createElement(CrossLinksGroupItems, {
            data: group,
            key: "groups-".concat({
                index: index
            }),
            collapsedAnalytics: collapsedAnalytics,
            expandedAnalytics: expandedAnalytics,
            expandedByDefault: expanded
        }));
    }))))));
};
CrossLinksExpando.displayName = "CrossLinksExpando";
export { CrossLinksExpando };
//# sourceMappingURL=index.js.map